import '../scss/_index.scss';

const DEFAULT_PARAMS = {
	resizeMedia: '(min-width: 975px)',
	cssClasses: {
		menu: 'nav-main',
		menuItem: 'nav-item',
		menuLink: 'nav-link',
		itemIsActive: 'is-active',
		itemIsNested: 'is-nested'
	}
};

class MainNavigation extends BX.Event.EventEmitter
{
	static get Events()
	{
		return {
			READY: 'onReady',
			REVEAL: 'reveal',
			CONCEAL: 'conceal'
		};
	}

	static get EventNamespace()
	{
		return 'Government.MainNavigation';
	}

	constructor(element, params)
	{
		super();
		this.setEventNamespace(MainNavigation.EventNamespace);

		this.element = element;
		this.params = { ...DEFAULT_PARAMS, ...params };

		if ('ResizeObserver' in window)
		{
			const resizeObserver = new ResizeObserver(BX.debounce(this.resize.bind(this), 100));
			resizeObserver.observe(document.body);
		}
		else
		{
			window.addEventListener('resize', BX.debounce(this.resize.bind(this), 100));
		}

		this.initBase();
		this.initKeyboard();
		this.initTouch();

		BX.Event.EventEmitter.emit(
			window,
			`${MainNavigation.EventNamespace}.${MainNavigation.Events.READY}`,
			this
		);
	}

	initBase()
	{
		this.element.addEventListener(
			'mouseenter',
			this.handleIn.bind(this),
			true
		);

		this.element.addEventListener(
			'mouseleave',
			this.handleOut.bind(this),
			true
		);
	}

	initKeyboard()
	{
		this.activeFocusItems = new WeakSet();

		this.element.addEventListener(
			'keydown',
			this.handleKeyDown.bind(this),
			true
		);

		this.element.addEventListener(
			'focusin',
			this.handleFocusIn.bind(this)
		);

		document.addEventListener(
			'focusout',
			this.handleFocusOut()
		);

		this.subscribe(MainNavigation.Events.CONCEAL, ({ data }) => {
			this.activeFocusItems.delete(data.item);
		});
	}

	handleKeyDown(event)
	{
		const { target, code } = event;
		const targetItem = target.closest(`.${this.params.cssClasses.menuItem}`);

		if (!targetItem)
			return;

		if (
			code === 'Enter'
			&& targetItem.classList.contains(this.params.cssClasses.itemIsNested)
			&& !this.activeFocusItems.has(targetItem)
		)
		{
			event.preventDefault();
			targetItem.classList.add(this.params.cssClasses.itemIsActive);
			this.activeFocusItems.add(targetItem);
		}
		else if (code === 'Escape' || code === 'Esc')
		{
			targetItem.classList.remove(this.params.cssClasses.itemIsActive);
			this.activeFocusItems.delete(targetItem);

			targetItem.querySelector(`.${this.params.cssClasses.menuLink}`)?.focus();
		}
	}


	handleFocusIn({ target })
	{
		const targetItem = target.closest(`.${this.params.cssClasses.menuItem}`);
		[...this.element.querySelectorAll(`.${this.params.cssClasses.menuItem}`)]
			.filter(
				item =>
					item.matches(`.${this.params.cssClasses.itemIsActive}`) &&
					item !== targetItem && !item.contains(targetItem) && !targetItem.contains(item)
			)
			.forEach(item => this.conceal(item));
	}

	handleFocusOut()
	{
		setTimeout(() => {
			if (this.element.contains(document.activeElement))
				return;

			this.closeAll();
		});
	}

	handleIn({ target })
	{
		if (
			!target.matches(`.${this.params.cssClasses.menuItem}`)
			|| target.parentNode !== this.element
		)
		{
			return;
		}

		clearTimeout(this.tId)
		this.tId = null;

		this.reveal(target);
	}

	handleOut({ target })
	{
		if (
			!target.matches(`.${this.params.cssClasses.menuItem}`)
			|| !target.classList.contains(this.params.cssClasses.itemIsActive)
		)
		{
			return;
		}

		this.tId = setTimeout(() => {
			this.conceal(target);
		}, 500);
	}

	closeAll()
	{
		[...this.element.querySelectorAll(`.${this.params.cssClasses.itemIsActive}`)]
			.forEach(item => this.conceal(item));
	}

	reveal(item)
	{
		this.element.querySelector(`.${this.params.cssClasses.itemIsActive}`)
			?.classList.remove(this.params.cssClasses.itemIsActive);

		item.classList.add(this.params.cssClasses.itemIsActive);

		this.emit(MainNavigation.Events.REVEAL, { item });
	}

	conceal(item)
	{
		item.classList.remove(this.params.cssClasses.itemIsActive);

		this.emit(MainNavigation.Events.CONCEAL, { item });
	}


	initTouch()
	{
		const touchedItems = new WeakSet();
		let touched = false;

		this.element.addEventListener(
			'touchstart',
			() => { touched = true },
			{ capture: true, passive: true }
		);

		this.element.addEventListener(
			'touchend',
			() => { setTimeout(() => { touched = false }); },
			true
		);

		const links = this.element.querySelectorAll(`.${this.params.cssClasses.menuLink}`);
		[...links].forEach(link => {
			const item = link.parentNode;
			if (item.classList.contains(this.params.cssClasses.itemIsNested))
			{
				link.addEventListener('click', event => {
					if (touched && !touchedItems.has(item))
					{
						touchedItems.add(item);
						event.preventDefault();
					}
					else if (touched)
					touchedItems.delete(item);
				});
			}
		});

		this.subscribe(MainNavigation.Events.CONCEAL, ({ data }) => {
			touchedItems.delete(data.item);
		});
	}

	resize()
	{
		if(
			!this.params.resizeMedia ||
			!window.matchMedia(this.params.resizeMedia).matches
		)
			return;

		mainMenuResizer(this.element);
	}
}

export { MainNavigation };